// Row shapes returned by the API (see src/server/api.ts and migrations/).

export interface Word {
	id: number;
	audio_url: string | null;
	char_type_name: string;
	line_number: number;
	page_number: number;
	text: string;
	translation_en: string;
	translation_bs: string | null;
	color: string | null;
	shape: string | null;
	ayah_id: number;
}

export interface Ayah {
	id: number;
	verse_number: number;
	verse_key: string;
	page_number: number;
	translation_en: string;
	translation_bs: string;
}

export type AyahWithWords = Ayah & { words: Word[] };

export interface Video {
	id: number;
	page_number: number;
	hifz_youtube_url: string | null;
	tajweed_youtube_url: string | null;
}

export interface Juz {
	id: number;
	number: number;
	page_start: number;
	page_end: number;
}

export interface Surah {
	id: number;
	number: number;
	revelation_place: string;
	revelation_order: string;
	name_simple: string;
	name_bosnian: string;
	name_arabic: string;
	verses_count: number;
	pages: string;
}

export interface RubWithSurah {
	id: number;
	number: number;
	text: string;
	juz: number;
	page: number;
	hizb_quarter: number;
	surah: Pick<Surah, "id" | "name_simple" | "name_bosnian" | "name_arabic">;
}

export interface PageData {
	pageNumber: number;
	ayahs: AyahWithWords[];
	video: Video | null;
	/** True when the request carries a valid admin session. */
	editMode: boolean;
}

export const WORD_COLORS = [
	"RED",
	"BLUE",
	"GREEN",
	"YELLOW",
	"ORANGE",
	"TRANSPARENT",
] as const;
export const WORD_SHAPES = [
	"SQUARE",
	"SQUARE-BORDER-ONLY",
	"CIRCLE",
	"CIRCLE-BORDER-ONLY",
] as const;

export const PAGE_COUNT = 604;
